export enum Storage {
    PROJECT_EMISSIONS_PAYLOAD = 'projectEmissionsPayload',
    PROJECT_EMISSIONS_RESPONSE = 'projectEmissionsResponse',
}
